import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../../common_components/mdae-framework";

import { cloneDeep } from "lodash";
import { GET_TARGET_RATIONALE_LIST } from "../services/get-target-rationale-list";
import { GET_RAC_APPROVED_TOPICS_LIST } from "../services/get-rac-approved-topics-list";
import { convertMixedHTMLToTextList } from "../constant";
import { GET_CODE_TYPES_LOOKUPS } from "../../../external-audit/services/get-code-types-lookups";

export const TOGGLE_TARGET_RATIONALE_DETAIL_POPUP =
  "TOGGLE_TARGET_RATIONALE_DETAIL_POPUP";
export const RESET_TARGET_RATIONALE_DETAIL_POPUP_VALIDATION =
  "RESET_TARGET_RATIONALE_DETAIL_POPUP_VALIDATION";
export const SET_TARGET_RATIONALE_FORM_DATA = "SET_TARGET_RATIONALE_FORM_DATA";
export const TOGGLE_TARGET_RATIONALE_WARNING_POPUP =
  "TOGGLE_TARGET_RATIONALE_WARNING_POPUP";
export const CLOSE_TARGET_RATIONALE_POP_UP_AFTER_SAVE =
  "CLOSE_TARGET_RATIONALE_POP_UP_AFTER_SAVE";
export const TOGGLE_RAC_APPROVED_TOPICS_LIST_ACTION_POPOVER =
  "TOGGLE_RAC_APPROVED_TOPICS_LIST_ACTION_POPOVER";
export const SET_RAC_APPROVED_TOPICS_FORM_DATA =
  "SET_RAC_APPROVED_TOPICS_FORM_DATA";
export const TOGGLE_RAC_APPROVED_TOPICS_POPUP =
  "TOGGLE_RAC_APPROVED_TOPICS_POPUP";
export const SET_SELECTED_RAC_APPROVED_TOPIC =
  "SET_SELECTED_RAC_APPROVED_TOPIC";
export const SET_TARGET_TYPE_VALUE_DATA_SOURCE =
  "SET_TARGET_TYPE_VALUE_DATA_SOURCE";

export const defaultTargetRationaleFormData = {
  targetRationaleId: 0,
  issueName: "",
  payer: "",
  payerGroup: "",
  description: "",
  applicablePolicyReferences: "",
  remitPayerId: null,
  payerGroupId: null,
  targetType: null,
  targetValue: [],
  curated:false
};

const initialState = {
  isLoading: false,
  targetRationaleFormData: defaultTargetRationaleFormData,
  payerGroupsList: [],
  targetRationaleList: [],
  isRACApprovedTopicsPopUpVisible: false,
  linkedRemitPayersDataList: [],
  targetTypeList: [],
  patientTypes: []  
};

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_TARGET_RATIONALE_LIST)(action)) {
        return {
          ...state,
          targetRationaleList: [],
          isLoading: false,
        };
      }
      if (isAsyncComplete(GET_TARGET_RATIONALE_LIST)(action)) {
        const response = action.response;
        const transformedList = response.targetRationaleList.map((item) => ({
          ...item,
          applicablePolicyReferences: convertMixedHTMLToTextList(
            item.applicablePolicyReferences
          ),
        }));
        return {
          ...state,
          targetRationaleList: transformedList,
          isLoading: true,
        };
      }
      if (isAsyncOperation(GET_RAC_APPROVED_TOPICS_LIST)(action)) {
        return {
          ...state,
          racApprovedTopicsList: [],
        };
      }
      if (isAsyncComplete(GET_RAC_APPROVED_TOPICS_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          racApprovedTopicsList: response.racApprovedTopicsList,
          isLoading: true,
        };
      }
      if (isAsyncOperation(GET_TARGET_RATIONALE_LIST)(action)) {
        return {
          ...state,
          payerGroupsList: [],
          isLoading: false,
        };
      }
      if (isAsyncComplete(GET_TARGET_RATIONALE_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          payerGroupsList: response.payerGroupsList,
          isLoading: true,
        };
      }
      if (isAsyncOperation(GET_CODE_TYPES_LOOKUPS)(action)) {
        return { ...state, targetTypeList: [] };
      }
      if (isAsyncComplete(GET_CODE_TYPES_LOOKUPS)(action)) {
        const response = action.response;
        return {
          ...state,
          targetTypeList: response.targetTypesList,
          patientTypes: response.patientTypes,
        };
      }
      return state;

    case TOGGLE_TARGET_RATIONALE_DETAIL_POPUP:
    case TOGGLE_RAC_APPROVED_TOPICS_LIST_ACTION_POPOVER:
      return { ...state, ...action.data };
    case SET_SELECTED_RAC_APPROVED_TOPIC:
      return {
        ...state,
        selectedRACApprovedTopic: action.data,
      };
    case SET_TARGET_RATIONALE_FORM_DATA:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = {
          ...newState,
          targetRationaleFormData: {
            ...state.targetRationaleFormData,
            ...action.data.targetRationaleFormData,
          },
        };
      }
      return newState;

    case RESET_TARGET_RATIONALE_DETAIL_POPUP_VALIDATION:
    case TOGGLE_TARGET_RATIONALE_WARNING_POPUP:
    case CLOSE_TARGET_RATIONALE_POP_UP_AFTER_SAVE:
    case SET_RAC_APPROVED_TOPICS_FORM_DATA:
    case TOGGLE_RAC_APPROVED_TOPICS_POPUP:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case SET_TARGET_TYPE_VALUE_DATA_SOURCE:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        if (action.currentCodeLookupCategroyId == 1) {
          newState = {
            ...newState,
            targetTypeValueSource: action.targetTypeValueSource,
          };
        }
      }
      return newState;
    default:
      return state;
  }
}
export const formatTargetrationaleDataObject = (targetrationaleData) => {
  const targetValue = targetrationaleData.targetValue?.toString();
  if (targetValue?.endsWith(",")) {
    targetrationaleData.targetValue = targetValue.slice(0, -1);
  } else {
    targetrationaleData.targetValue = targetValue;
  }
  return { ...targetrationaleData };
};
export const formatFetchedTargetRationaleData = (data) => {
  if (
    data?.targetType &&
    data?.targetType?.toUpperCase() !== "OTHER" &&
    data?.targetType?.toUpperCase() !== "PT" &&
    data?.targetType != ""
  ) {
    data.targetValue = data?.targetValue?.split(",");
  } else {
    data.targetValue = data?.targetValue?.toString();
  }
  return { ...data };
};
